var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRequestAccepted = function SvgRequestAccepted(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#54AF97",
    fillRule: "evenodd",
    d: "M.628 5.993l2.205 2.253a.98.98 0 0 0 1.436-.038l5.13-5.822a.98.98 0 0 0-.036-1.334L9.068.75a.98.98 0 0 0-1.433.034L3.571 5.351l-1.156-1.18a.98.98 0 0 0-1.444.047l-.387.452a.98.98 0 0 0 .044 1.323z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRequestAccepted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/request-accepted.112ded98c5c048fb7ed496e7f06d0c5f.svg";